export default __webpack_public_path__ + "static/media/egg_slider.483ab407.webp";